import { useEffect, useRef } from 'react';

const useRefreshOnFocus = (refresh, { enabled = true } = {}) => {
  const refreshRef = useRef(refresh);

  useEffect(() => {
    refreshRef.current = refresh;
  }, [refresh]);

  useEffect(() => {
    if (!enabled) return undefined;

    let lastRun = 0;
    const run = () => {
      const now = Date.now();
      if (now - lastRun < 1000) return;
      lastRun = now;
      refreshRef.current?.();
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') run();
    };

    window.addEventListener('focus', run);
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      window.removeEventListener('focus', run);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [enabled]);
};

export default useRefreshOnFocus;
